declare const ajaxObject: {
  action: string,
  nonce: string,
  url: string,
}

type UIType = {
  sort: HTMLSelectElement | null,
  more: HTMLButtonElement | null,
  grid: HTMLElement | null,
}

interface Data {
  action: string,
  security: string,
  termID: string,
  limit: number,
  paged: number,
  order: string,
  total: number,
}

export default (module: HTMLElement) => {
  const UI: UIType = {
    sort: module.querySelector('[data-program-sort] select'),
    more: module.querySelector('[data-program-more]'),
    grid: module.querySelector('[data-program-grid]'),
  }

  const DATA: Data = {
    action: ajaxObject.action,
    security: ajaxObject.nonce,
    termID: module.getAttribute('data-term-id'),
    limit: parseInt(module.getAttribute('data-limit')),
    paged: 1,
    order: UI.sort?.value,
    total: parseInt(module.getAttribute('data-total')),
  }

  const getReplays = async (clear: boolean = false) => {
    // Start loading
    UI.grid?.classList.add('opacity-50', 'pointer-events-none')
    
    if (UI.more) {
      UI.more.setAttribute('data-state', 'loading')
    }

    // Fetch data
    const req = await fetch(ajaxObject.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      // @ts-ignore
      body: new URLSearchParams(DATA),
    })

    if (req.ok) {
      const res = await req.json()
      if (clear) {
        UI.grid.innerHTML = res.data.template
      } else {
        UI.grid.insertAdjacentHTML('beforeend', res.data.template)
      }
    } else {
      console.error('HTTP-Error: ' + req.status)
    }

    if (UI.more) {
      if (DATA.paged * DATA.limit >= DATA.total) {
        UI.more?.classList.add('hidden')
      } else {
        UI.more?.classList.remove('hidden')
      }
    }

    // End loading
    UI.grid?.classList.remove('opacity-50', 'pointer-events-none')
    UI.more.setAttribute('data-state', 'ready')
  }

  const handleSortChange = (e: Event) => {
    e.preventDefault()
    const target = e.currentTarget as HTMLSelectElement
    const order = target.value
    DATA.order = order
    DATA.paged = 1
    getReplays(true)
  }

  const handleLoadmore = (e: Event) => {
    e.preventDefault()
    DATA.paged++
    getReplays()
  }

  UI.sort?.addEventListener('change', handleSortChange)
  UI.more?.addEventListener('click', handleLoadmore)
}